const VersionInfo = {
  version: '2.7.2',
  major: 2,
  minor: 7,
  patch: 2,
  suffix: '',
  isNext: false,
  buildTime: 1739454070
};
export default VersionInfo;